/**
 * Threshold rules persisted on the widget as a JSON array. Each rule is
 * a horizontal line on time-series charts and a colour pick on stat/gauge.
 *
 *   [{ value: 80, color: '#d4380d', op: 'gt', label: 'Critical' }, ...]
 *
 * Defensive parser — any malformed entry is dropped silently rather than
 * throwing in the chart render path.
 */
export const parseThresholds = (json) => {
  if (!json) return [];
  try {
    const arr = typeof json === 'string' ? JSON.parse(json) : json;
    if (!Array.isArray(arr)) return [];
    return arr
      .filter(t => t && (typeof t.value === 'number' || !isNaN(parseFloat(t.value))))
      .map(t => ({
        value: typeof t.value === 'number' ? t.value : parseFloat(t.value),
        color: t.color || '#d4380d',
        op: t.op === 'lt' ? 'lt' : 'gt',
        label: t.label || '',
        fillBelow: !!t.fillBelow,
      }));
  } catch {
    return [];
  }
};

/**
 * Pick the matching threshold for a single value (used by stat / gauge
 * widgets to colour the displayed number). Rules are evaluated in order;
 * first match wins. {@code op === 'gt'} matches if {@code value >= rule.value};
 * {@code op === 'lt'} matches if {@code value <= rule.value}.
 */
export const matchThreshold = (value, thresholds) => {
  if (value == null || isNaN(value)) return null;
  for (const t of thresholds) {
    if (t.op === 'gt' && value >= t.value) return t;
    if (t.op === 'lt' && value <= t.value) return t;
  }
  return null;
};
